module.exports = __webpack_public_path__ + "img/Liesl Eichholz.66c73a4d.jpg";